import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import StateMachine from "slotworks/state-machine/state-machine";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class AutoplayStartButtonControl extends AbstractButtonControl implements Control {

    private autoStarted: boolean;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.autoStarted = false;
    }

    public updateOptions(options: ControlOptions) {
        this.button.setEnabled(options.autoplays.currentValue > 0);

        super.updateOptions(options);
    }

    public setEnabled() {
        // Cancel default
    }

    public destroy() {
        if (!this.autoStarted) {
            this.clearAutoplay();
        }

        super.destroy();
    }

    protected onClick() {
        this.autoStarted = true;

        SmartUIFlags.set(SmartUIFlag.AUTO_SPIN, true);

        const options = new ControlOptions();
        this.onChange.dispatch(options);
        Services.autoplay.start();

        StateMachine.skip();
    }

    protected clearAutoplay() {
        const options = new ControlOptions();
        options.flashLossLimit = false;
        options.autoplays.currentValue = 0;
        options.lossLimit.currentValue = this.options.lossLimit.defaultValue;
        options.singleWinLimit.currentValue = this.options.singleWinLimit.defaultValue;
        options.totalWinLimit.currentValue = this.options.totalWinLimit.defaultValue;
        options.customLossLimitSelected = false;
        options.customAutoplayCountSelected = false;
        options.customSingleWinLimitSelected = false;

        this.onChange.dispatch(options);
    }
}
